// Anodizado en la tabla de pedido de la ficha (snippets/anodizado-fila.liquid).
// La tabla (quick-order-list.js) se vuelve a dibujar en cada cambio del carrito, así que todo va delegado
// en document y se recuerda qué desplegables estaban abiertos para reabrirlos.
(function () {
  if (window.__anodizado) return;
  window.__anodizado = true;

  var abiertos = {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener(
    'toggle',
    function (e) {
      var d = e.target;
      if (d.matches && d.matches('details[data-anod]')) abiertos[d.dataset.anod] = d.open;
    },
    true
  );

  function reabrir() {
    document.querySelectorAll('details[data-anod]').forEach(function (d) {
      if (abiertos[d.dataset.anod] && !d.open) d.open = true;
    });
  }
  new MutationObserver(reabrir).observe(document.documentElement, { childList: true, subtree: true });

  function pedir(url, body) {
    body.sections = 'cart-icon-bubble';
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw d;
        return d;
      });
    });
  }

  function despues(d) {
    var burbuja = document.getElementById('cart-icon-bubble');
    if (burbuja && d.sections && d.sections['cart-icon-bubble']) {
      var s = new DOMParser().parseFromString(d.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (s) burbuja.innerHTML = s.innerHTML;
    }
    // la tabla escucha este evento y se vuelve a dibujar con el anodizado actualizado
    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'anodizado' });
  }

  function error(caja, msg) {
    var e = caja.querySelector('.anod__error');
    e.textContent = msg || '';
    e.hidden = !msg;
  }

  document.addEventListener('click', function (e) {
    var boton = e.target.closest('details[data-anod] [data-accion]');
    if (!boton) return;
    e.preventDefault();
    var caja = boton.closest('details[data-anod]');
    var accion = boton.dataset.accion;
    var peticion;

    if (accion === 'agregar') {
      var libres = parseInt(caja.dataset.libres, 10);
      var cantidad = parseInt(caja.querySelector('.anod__num').value, 10);
      if (!(cantidad >= 1) || cantidad > libres) return error(caja, 'Escribe una cantidad entre 1 y ' + libres + '.');
      peticion = pedir('cart/add.js', {
        items: [{ id: parseInt(caja.querySelector('.anod__sel').value, 10), quantity: cantidad, properties: { Para: caja.dataset.para } }],
      });
    } else {
      var linea = boton.closest('.anod__linea');
      var actual = parseInt(linea.dataset.cant, 10);
      var nueva = { menos: actual - 1, mas: actual + 1, quitar: 0 }[accion];
      peticion = pedir('cart/change.js', { id: linea.dataset.key, quantity: nueva });
    }

    error(caja, '');
    caja.querySelectorAll('button, select, input').forEach(function (el) { el.disabled = true; });
    abiertos[caja.dataset.anod] = true;
    peticion.then(despues).catch(function (d) {
      error(caja, (d && (d.description || d.message)) || 'No se pudo actualizar el anodizado. Intenta de nuevo.');
      caja.querySelectorAll('button, select, input').forEach(function (el) { el.disabled = false; });
    });
  });
})();
